import { get, set, unset } from "lodash-es"
import { useSelector, useDispatch } from "react-redux"
export const SELECT_ROW = "SELECT_ROW "
export const SELECT_ALL_ROWS = "SELECT_ALL_ROWS"
export const UPDATE_ROW = "UPDATE_ROW"
export const RESET_SELECTED = "RESET_SELECTED"
export const RESET_SELECT_ALL = "RESET_SELECT_ALL"
export const SELECT_ALL_FILTER = "SELECT_ALL_FILTER"

const INITIAL_STATE = {
  vehicles: {
    selected: {},
    selectAll: false,
    selectAllFilter: false,
  },
}

export function selectorReducer(state = INITIAL_STATE, action) {
  switch (action?.type) {
    case SELECT_ALL_FILTER:
      const isSelected = state?.[action.path]?.selectAllFilter
      return {
        ...state,
        [action?.path]: {
          selected: {},
          selectAll: false,
          selectAllFilter: !isSelected,
        },
      }

    case SELECT_ROW:
      const selected = { ...state?.[action.path]?.selected }

      if (selected[action?.payload?.id]) {
        unset(selected, action?.payload?.id)
      } else {
        set(selected, action?.payload?.id, action.payload)
      }
      return {
        ...state,
        [action?.path]: {
          selected,
          selectAll: false,
          selectAllFilter: false,
        },
      }

    case SELECT_ALL_ROWS:
      if (state?.[action.path]?.selectAll) {
        return {
          ...state,
          [action.path]: {
            selected: {},
            selectAll: false,
            selectAllFilter: false,
          },
        }
      } else {
        const selected = { ...state?.[action.path]?.selected }

        action.payload && action.payload.forEach(p => set(selected, p.id, p))
        return {
          ...state,
          [action?.path]: { selected, selectAll: true, selectAllFilter: false },
        }
      }

    case UPDATE_ROW:
      return {
        ...state,
        [action.path]: {
          ...state[action.path],
          selected: {
            ...state[action.path]?.selected,
            [action?.payload?.id]: action?.payload,
          },
          selectAllFilter: false,
        },
      }

    case RESET_SELECTED:
      return {
        ...state,
        [action.path]: {
          selected: {},
          selectAll: false,
          selectAllFilter: false,
        },
      }

    case RESET_SELECT_ALL:
      return {
        ...state,
        [action.path]: {
          ...state[action.path],
          selectAll: false,
          selectAllFilter: false,
        },
      }
    default:
      return state
  }
}

export function useSelectedIds(path) {
  return useSelector((state: any) => {
    /**
     * Path means - the name of the collection (eg. demands, vehicles)
     */
    const selectedItemsObject = get(state.selector, `${path}.selected`)
    /**
     * If there are selected items then return the array of ids else return and empty array
     * []
     */
    return selectedItemsObject && Object.keys(selectedItemsObject)
      ? Object.keys(selectedItemsObject)
      : []
  })
}

export function useSelectedTotal(path) {
  return useSelector((state: any) => {
    /**
     * Path means - the name of the collection (eg. demands, vehicles)
     */
    const selectedItemsObject = get(state.selector, `${path}.selected`)
    /**
     * If there are selected items then return the array of ids else return and empty array
     * []
     */
    return selectedItemsObject && Object.keys(selectedItemsObject)
      ? Object.keys(selectedItemsObject)?.length
      : 0
  })
}

export function useSelected(path) {
  return useSelector((state: any) => get(state.selector, `${path}.selected`))
}

export function useResetSelected(path) {
  const dispatch = useDispatch()

  function reset() {
    dispatch({
      type: RESET_SELECTED,
      path,
    })
  }
  return reset
}

export function useSelectedArray(path) {
  return useSelector((state: any) => {
    /**
     * Path means - the name of the collection (eg. demands, vehicles)
     */
    const selectedItemsObject = get(state.selector, `${path}.selected`)
    /**
     * If there are selected items then return the array of ids else return and empty array
     * []
     */
    return selectedItemsObject && Object.values(selectedItemsObject)
      ? Object.values(selectedItemsObject)
      : []
  })
}
